import {
    formattedKeyValuePairs,
    getNavigator,
    getUserBrowser,
    getUserDevice,
    getUserOs,
    isChromiumBased,
    isIOS,
    isSafeRedirectUrl,
    isSafari,
    isUserOsMobile,
    navigateToExternalUrl as webCommonNavigateToExternalUrl,
    sanitizeRedirectUrl,
} from '@calm/web-common/dist/browser';
import isSSR from '@calm/web-common/dist/isSSR';
import { CYPRESS_USER_AGENT, RHG_HEADER } from '@rhg/utils/constants';
import { extractAppConfig } from '../app-config';

export {
    formattedKeyValuePairs,
    getNavigator,
    getUserBrowser,
    getUserDevice,
    getUserOs,
    isChromiumBased,
    isIOS,
    isSafeRedirectUrl,
    isSafari,
    isUserOsMobile,
    sanitizeRedirectUrl,
};

export function isAndroid() {
    return getUserOs().name === 'Android';
}

// Wrapper so jest.spyOn can intercept this in tests (re-exported ES module
// properties are non-configurable and cannot be redefined by spyOn)
export function navigateToExternalUrl(url: string): void {
    webCommonNavigateToExternalUrl(url);
}

export function getRhgAppHeaderObject() {
    if (isSSR()) {
        return {};
    }

    const { NEXT_PUBLIC_VERSION } = extractAppConfig();
    const os = getUserOs();
    const browser = getUserBrowser().name;
    const isMobileBrowser = isUserOsMobile();

    return {
        /**
         * Only used in logging
         */
        app: 'evexia_web',
        /**
         * Used by the media service to serve correct content
         * DeviceType in reporting
         */
        platform: isMobileBrowser ? os.name?.toLowerCase() : 'www',
        /**
         * AppVersion in reporting
         */
        version: NEXT_PUBLIC_VERSION,
        /**
         * DeviceOS in reporting
         */
        os: `${os.name} ${os.version}`,
        /**
         * DeviceModel in reporting
         */
        'device-model': browser,
    };
}

export function getRhgAppHeader() {
    if (isSSR()) {
        return '';
    }
    return formattedKeyValuePairs(getRhgAppHeaderObject());
}

export function getRhgE2ETestHeader() {
    if (isSSR()) {
        return '';
    }

    if (window.navigator.userAgent === CYPRESS_USER_AGENT) {
        return 'undefined-evexia-e2e;';
    }
}

export function getFormattedRhgHeader(
    header: RHG_HEADER,
    keyValuePairs: { [key: string]: string | undefined } = {}
) {
    return {
        [header]: formattedKeyValuePairs(keyValuePairs),
    };
}

export function getRhgAppAppendHeader(
    keyValuePairs: { [key: string]: string | undefined } = {}
) {
    return getFormattedRhgHeader(RHG_HEADER.APP_APPEND, keyValuePairs);
}
